import { formatMomentToValueDate } from '../../../components/helpers/formatMomentToValueDate';
import { formatValueDateToMoment } from '../../../components/helpers/formatValueDateToMoment';
import { values } from '@morf/proto/values/v1/values_ts_proto';

export const goToNextMonth = (date: values.v1.Date): values.v1.Date => {
  const nextMonthMoment = formatValueDateToMoment(date)
    .startOf('month')
    .add(1, 'month')
    .startOf('week');
  return formatMomentToValueDate(nextMonthMoment);
};
